

const emitter = {
    events:{},
    on(event,callback,subscriberKey){
        if (!this.events[event]) {
            this.events[event] = {};
        }
        if (!this.events[event][subscriberKey]) {
            this.events[event][subscriberKey] = callback;
        }
    },
    emmit(event,data){
        if (!this.events[event]) return;
        Object.values(this.events[event]).forEach(callback => callback(data))
    },
    unSubscribe(event,subscriberKey){
        if(event in this.events){
            delete this.events[event][subscriberKey];
        }
    }
}

export {emitter};


// WEBPACK FOOTER //
// ./src/services/emitter/index.js